'use es6';

export const FILE = '__NATIVE_FILE__';
export const URL = '__NATIVE_URL__';
export const TEXT = '__NATIVE_TEXT__';
export const HTML = '__NATIVE_HTML__';